// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".ac89bdda9c9e5896b71b3909ed951f7c.js";
};